import { useEffect, useRef, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { FaDownload } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from 'yup'
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import { ERROR_MSG } from "../../CommonUtils/contextVariables";
import { CommonAxiosGet, CommonAxiosPost } from "../../CommonUtils/CommonAxios";
import { config } from "../../CommonUtils/CommonURLS";
import { failureAlert } from "../../CommonUtils/SweetAlerts";
import { viewImage } from "../../CommonUtils/viewImage";
import CommonReactTable from "../../CommonUtils/CommonReactTable";


export default function Ffcaunivpercentdrill(props) {
    const hasFetchedData = useRef(false)
    const [data, setData] = useState([])
    const acYear = sessionStorage.getItem('ac_year');

    const [row, setRow] = useState([])
    const dispatch = useDispatch()
    const validations = Yup.object({
        remarks: Yup.string().required(ERROR_MSG)
    })

    const formik = useFormik({
        initialValues: {
            remarks: ''
        },
        validationSchema: validations,
        onSubmit: () => {
            let payload = {
                empId: row?.original?.emp_id,
                remarks: formik.values.remarks
            }
            let url = config.url.API_URL + `DeleteEmployee`
            CommonAxiosPost(url, payload, dispatch).then((res) => {
                if (res.data.scode === '01') {
                    Swal.fire('Deleted Successfully', '', 'success').then((succ) => {
                        if (succ?.isConfirmed) {
                            window.location.reload()
                        }
                    })
                }
                else {
                    failureAlert("Failed to submit")

                }
            })
        }
    })
    const { ubcode, start, end, Setdrilldown } = props

    function GetData() {
        let url = config.url.API_URL + `getcollegesreportffcadrill/` + ubcode + '/' + start + '/' + end
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setData(res?.data?.data)

            }
        })
    }


    function GetClgSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + acYear;
        CommonAxiosPost(url, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)

            }
        })
    }
    const Columns = [
        {
            Header: "Sl.no",
            accessor: (row, index) => index + 1,
        },
        {
            Header: "College Code",
            accessor: "coll_code",
            Cell: ({ row }) => <div>{row?.values?.coll_code ? row?.values?.coll_code : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "College Name",
            accessor: "inst_name",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.original?.inst_name}</div>
        },
        {
            Header: "Officer Details",
            accessor: "officer_details",
            Cell: ({ row }) => {
                const details = row?.values?.officer_details;
                return (
                    <div style={{ textAlign: 'left' }}>
                        {details ? (
                            <>
                                {details.split("<br/>")[0]} <br />
                                {details.split("<br/>")[1]}
                            </>
                        ) : (
                            <b style={{ textAlign: 'center' }}>-</b>
                        )}
                    </div>
                );
            },
        },

        {
            Header: "Verification Type",
            accessor: "verification_type",
            Cell: ({ row }) => <div style={{ textAlign: 'left' }}>{row?.values?.verification_type ? row?.values?.verification_type : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "FFCA Member Details",
            accessor: "ffca_mem_section",
            Cell: ({ row }) => <div>{row?.original?.ffca_mem_section}</div>
        },
        {
            Header: "Fee Dues to the University",
            accessor: "fee_due_univ",
            ell: ({ row }) => <div>{row?.original?.fee_due_univ}</div>

        },
        {
            Header: "Link Upload",
            accessor: "ffca_link_upload",
            Cell: ({ row }) => <div>{row?.values?.ffca_link_upload ? row?.values?.ffca_link_upload : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },


        // {
        //     Header: "FFCA Geo Location",
        //     accessor: "ffca_geo_location",
        //     Cell: ({ row }) => <div>{row?.values?.ffca_geo_location ? row?.values?.ffca_geo_location : <b style={{ textAlign: 'center' }}>-</b>}</div>
        // },

        {
            Header: "Building Blocks Report",
            accessor: "ffca_build_blocks",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.ffca_build_blocks ? row?.values?.ffca_build_blocks : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Infrastructural Area Report",
            accessor: "ffca_instruct_area",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.ffca_instruct_area ? row?.values?.ffca_instruct_area : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Administrative Area Report",
            accessor: "ffca_admin_area",
            ell: ({ row }) => <div>{row?.original?.ffca_admin_area}</div>
        },
        {
            Header: "Lab Area Details",
            accessor: "ffca_lab_area",
            ell: ({ row }) => <div>{row?.original?.ffca_lab_area}</div>

        },
        {
            Header: "Questionnaire Section 1",
            accessor: "ffca_ques_sect_1",
            Cell: ({ row }) => <div>{row?.values?.ffca_ques_sect_1 ? row?.values?.ffca_ques_sect_1 : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Questionnaire Section 2",
            accessor: "ffca_ques_sect_2",
            Cell: ({ row }) => <div>{row?.values?.ffca_ques_sect_2 ? row?.values?.ffca_ques_sect_2 : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        // ============
        {
            Header: "Questionnaire Section 3",
            accessor: "ffca_ques_sect_3",
            Cell: ({ row }) => <div>{row?.values?.ffca_ques_sect_3 ? row?.values?.ffca_ques_sect_3 : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "Questionnaire Section 4",
            accessor: "ffca_ques_sect_4",
            Cell: ({ row }) => <div>{row?.original?.ffca_ques_sect_4}</div>
        },
        {
            Header: "Feedback & Final Submission",
            accessor: "ffca_remarks",
            Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.ffca_remarks ? row?.values?.ffca_remarks : <b style={{ textAlign: 'center' }}>-</b>}</div>
        },
        {
            Header: "FFCA Application",
            // accessor: "pan_number",
            // Cell: ({ row }) => <div style={{ width: '80px' }}>{row?.values?.pan_number ? row?.values?.pan_number : <b style={{ textAlign: 'center' }}>-</b>}</div>
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn text-center"
                        onClick={() => {
                            GetClgSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FaDownload size={20} />
                    </button>
                )
            }
        },
    ]
    useEffect(() => {
        if (!hasFetchedData.current) {
            GetData()
            hasFetchedData.current = true
        }
    }, [])

    return (
        <>

            <Col xs={12} sm={12} md={12} lg={12} xl={12} xxl={12} className="d-flex justify-content-between align-items-center">
                <div className="inner-herbpage-service-title-sub pt-0"  >
                    <h1 className="m-0 p-0 pb-2">College Application Submission Percentage Report, Ac-Year - {acYear}</h1>
                </div>
            </Col>
            <Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5 " style={{ backgroundColor: '#FAF7F0' }}  >
                <Row>
                    <Col xs={11} sm={11} md={11} lg={11} xl={11} xxl={11} className="d-flex justify-content-between align-items-center">
                        <div className="inner-herbpage-service-title-sub pt-0"  >
                            <h1 className="m-0 p-0 pb-2">{start === '100' || '0' ? start : start + '-' + end} Percentage Report</h1>
                        </div>
                    </Col>
                    <Col xs={1} sm={1} md={1} lg={1} xl={1} xxl={1}>
                        <button type="button" className="btn btn-primary float-end" onClick={() => { Setdrilldown(0) }}>Back</button>
                    </Col>
                </Row>
                <br />
                {data && data?.length > 0 ? (
                    <CommonReactTable data={data} columns={Columns} excelFlag={true} printFlag={true} filename="College Application Submission Percentage Report" headerName='' />
                ) : (
                    <b className='text-error text-center'>No data Found</b>
                )}
            </Container>
        </>
    )
}
